// extracted by mini-css-extract-plugin
export default {"bannerContainer":"CookieBanner_bannerContainer__cFVNm","bannerText":"CookieBanner_bannerText__7SWff","buttonContainer":"CookieBanner_buttonContainer__3h7Uq"};